import { MenuItem } from '../../models';

/** holds items for my progress dropdown used in navbar */
export const STUDY_HABITS_ADMIN_NAV: MenuItem[] = [
  { title: 'Daily Schedule', link: '/practice-schedule' },
  { title: 'Study Visualizer', link: '/habits/visualizer' },
  { title: 'Daily Practice Habits', link: '/habits/report' },
];
